import { configureStore } from "@reduxjs/toolkit";
import selectedTableReducer from "./slices/selectedTableSlice";
import csrDataReducer from "./slices/csrDataSlice";
import scsDataReducer from "./slices/scsDataSlice";

export const store = configureStore({
  reducer: {
    selectedTable: selectedTableReducer,
    csrData: csrDataReducer,
    scsData: scsDataReducer,
  },
  devTools: true,
});
